/**
 * Renders a JSON-LD structured-data block. An inline
 * <script type="application/ld+json"> is valid anywhere in the document and is captured
 * by scripts/prerender.ts, so crawlers and rich-results parsers read it without running
 * the SPA. Use for page-specific schema (e.g. FAQPage); site-wide Organization/WebSite/
 * SoftwareApplication live statically in index.html.
 */
export function JsonLd({ data }: { data: object }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
